var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component, Fragment } from 'react';
import { Alignment, ModalType, Placement } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { arrayOf, bool, element, eventListener, oneOf, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { AbortableCloseEvent, CloseEvent, OpenEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { classNames, enumValues, isFunction, isXSmallResolution, trigger } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as ContextIcon } from '../../../resources/assets/components/DLS_MoreVertical.svg';
import { Modal } from '../modal/modal.js';
import { Popover } from '../popover/popover.js';
import { ContextMenuAPI } from './context-menu-api.js';
import './context-menu.css';
const ContextMenuContainer = {
    name: '',
};
let ContextMenu = class ContextMenu extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            open: false,
        };
        this.onClick = (event) => {
            const { preventDefault, stopPropagation } = this.props;
            if (preventDefault) {
                event.preventDefault();
            }
            if (stopPropagation) {
                event.stopPropagation();
            }
            this.popoverToggle();
        };
        this.onItemClick = () => {
            this.popoverToggle();
        };
        this.getTriggerEvent = () => {
            const { onClose, onOpen } = this.props;
            const { open } = this.state;
            if (open) {
                return trigger(onClose, new CloseEvent());
            }
            return trigger(onOpen, new OpenEvent());
        };
        this.popoverToggle = () => {
            const { open } = this.state;
            if (open && !this.shouldClose()) {
                return;
            }
            const triggerEvent = this.getTriggerEvent();
            this.setState(({ open }) => ({ open: !open }), () => triggerEvent());
        };
        this.shouldClose = () => {
            const { onBeforeClose } = this.props;
            let close = true;
            const abort = () => {
                close = false;
            };
            if (isFunction(onBeforeClose)) {
                onBeforeClose(new AbortableCloseEvent({ abort }));
            }
            return close;
        };
    }
    renderIcon() {
        return (React.createElement("div", { className: "c-context-menu__icon", onClick: this.onClick },
            React.createElement(ContextIcon, null)));
    }
    renderChildren() {
        const { children, uuid } = this.props;
        return (React.createElement(Container, { className: "u-expand", onClick: this.onItemClick, uuid: uuid }, children));
    }
    renderPopover() {
        const { alignment, placement } = this.props;
        const { open } = this.state;
        return (React.createElement(Popover, { alignment: alignment, className: "c-context-menu__popover", onClose: this.popoverToggle, open: open, padding: 8, placement: placement },
            this.renderIcon(),
            React.createElement(Popover.Content, null, this.renderChildren())));
    }
    renderModal() {
        const { open } = this.state;
        return (React.createElement(Fragment, null,
            this.renderIcon(),
            open &&
                React.createElement(Modal, { closeable: true, focusOnOpen: true, hideHeaderOnMobile: true, noPadding: isXSmallResolution(), onClose: this.popoverToggle, type: ModalType.DIALOG }, this.renderChildren())));
    }
    getClassName() {
        const { className } = this.props;
        return classNames({
            'c-context-menu': true,
            [`${className}`]: Boolean(className),
        });
    }
    render() {
        return (React.createElement("div", { className: this.getClassName() }, isXSmallResolution()
            ? this.renderModal()
            : this.renderPopover()));
    }
};
ContextMenu.propTypes = {
    alignment: oneOf(enumValues(Alignment)),
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    onBeforeClose: eventListener,
    onClose: eventListener,
    onOpen: eventListener,
    placement: oneOf(enumValues(Placement)),
    preventDefault: bool,
    stopPropagation: bool,
    uuid: string,
};
ContextMenu.defaultProps = {
    alignment: Alignment.CENTER,
    placement: Placement.BOTTOM,
    uuid: '',
};
ContextMenu = __decorate([
    AwesomeComponent({ api: ContextMenuAPI, containers: [ContextMenuContainer], type: ComponentType.NAVIGATION })
], ContextMenu);
export { ContextMenu, };
export default ContextMenu;
//# sourceMappingURL=context-menu.js.map